import { AppState } from '../reducers';

export const getCommissionStatementDates = (state: AppState) => state.commissionStatement.agentCommissionStatementDates;
export const getCommissionStatementSummary = (state: AppState) => state.commissionStatement.agentCommissionStatementSummary;